// extracted by mini-css-extract-plugin
export default {"container":"_5af83b6d","rating":"_c4e3e7cd","noReviews":"_78336862"};